import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";

import { tracking } from "../../../utils/tracking";
import { NewButton } from './NewButton';
import { SpecialOffer } from './SpecialOffer.js';
import "./NavBar.css";

const deadline = new Date('February 17 2023 00:00:00 PST');

const NavBarButtonsStyle = {
   height: '42px',
   color: 'white',
   fontFamily: "Poppins, sans-serif !important",
   borderRadius: "0px",
   fontSize: "16px",
}

const NavButton = ({ name, link, onClick }) => {

   const trackerId = name === "tickets" ? 256 : 257;

   return (
      <Link to={link} onClick={onClick}>
         <NewButton name={name} color='white' bgColor='#cf1b5b' onClick={() => tracking(trackerId)} />
      </Link >
   );
};

const BASE_URL = '/events/etvs23/';

const pages =
   [
      { name: 'startups', link: BASE_URL + 'startups', active: false },
      { name: 'speakers', link: BASE_URL + 'speakers', active: false },
      { name: 'agenda', link: BASE_URL + 'agenda', active: false },
      { name: 'partners', link: BASE_URL + 'partners', active: false },
      { name: 'venue', link: BASE_URL + 'venue', active: false },
   ];
const settings = ["Profile", "Account", "Dashboard", "Logout"];

export const NavBar = ({ myDiv }) => {
   const [anchorElUser, setAnchorElUser] = useState(null);
   const [showMenu, setShowMenu] = useState(false);
   const [width, setWidth] = useState(window.innerWidth)
   useEffect(() => {

      function updateSize() {
         setWidth(window.innerWidth);
      }
      window.addEventListener('resize', updateSize);
      updateSize();
      return () => window.removeEventListener('resize', updateSize);
   }, []);


   const handleCloseUserMenu = () => {
      setAnchorElUser(null);
   };

   //used in navlink buttons to change #investor-section link between a and link, and to change the link if in home
   let location = useLocation();
   const isRoot = location.pathname === "/" || location.pathname === BASE_URL;


   const NavLinkButton = ({ page }) => {
      const [active, setActive] = useState(false)

      let pageNames = page.link.split("/");
      let pageName = pageNames[pageNames.length - 1];

      let pageId;

      switch (pageName) {
         case "startups":
            pageId = 251;
            break;
         case "speakers":
            pageId = 252;
            break;
         case "agenda":
            pageId = 253;
            break;
         case "partners":
            pageId = 254;
            break;
         case "venue":
            pageId = 255;
            break;

         default:
            pageId = 0;
            break;
      }

      if (page.link.includes("#investor-section")) {
         if (isRoot) {
            page.link = "#investor-section";
         } else {
            page.link = BASE_URL + '#investor-section';
         }
      }


      // const showBorderBottom = window.location.href == page.link || window.location.href == `${page.link}/` || active || window.location.pathname.includes(page.name);
      return (
         page.link.includes("#investor-section") ?
            <a href={page.link} onClick={() => { tracking(pageId); }}>
               <Button
                  key={page.name}
                  onMouseEnter={e => setActive(true)}
                  onMouseLeave={e => setActive(false)}
                  sx={{
                     ...NavBarButtonsStyle,
                     gap: "7%",
                     borderBottom: '2px solid transparent',
                     borderBottomColor: (active || window.location.pathname.includes(page.name) || (window.location.pathname === BASE_URL && page.name === "overview")) && " white",
                  }}
               >
                  {page.name}
               </Button>
            </a>
            :
            <Link to={!location.pathname.includes(page.link + '/') && page.link} onClick={() => { tracking(pageId); }}>
               <Button
                  key={page.name}
                  onMouseEnter={e => setActive(true)}
                  onMouseLeave={e => setActive(false)}
                  sx={{
                     ...NavBarButtonsStyle,
                     borderBottom: '2px solid transparent',
                     borderBottomColor: (active || window.location.pathname.includes(page.name) || (window.location.pathname === BASE_URL && page.name === "overview")) && " white",
                  }}
               >
                  {page.name}
               </Button>
            </Link>
      )
   }

   const NavLinkButtonMobile = ({ page }) => {
      let pageNames = page.link.split("/");
      let pageName = pageNames[pageNames.length - 1];
      let pageId;

      switch (pageName) {
         case "startups":
            pageId = 251;
            break;
         case "speakers":
            pageId = 252;
            break;
         case "agenda":
            pageId = 253;
            break;
         case "partners":
            pageId = 254;
            break;
         case "venue":
            pageId = 255;
            break;
         default:
            pageId = 0;
            break;
      }

      if (page.link.includes("#investor-section")) {
         if (isRoot) {
            page.link = "#investor-section";
         } else {
            page.link = BASE_URL + "#investor-section";
         }
      }
      return (
         page.link.includes("#investor-section") ?
            <a href={page.link} onClick={() => {
               tracking(pageId);
            }}>
               <Typography
                  textAlign="left"
                  paddingLeft="35px"
                  lineHeight="2rem"
                  sx={{ fontFamily: "Poppins, sans-serif !important", color: "white", }}
               >
                  {page.name.toUpperCase()}
               </Typography>
            </a> :
            <Link to={page.link} onClick={() => {
               tracking(pageId);
            }}>
               <Typography
                  textAlign="left"
                  paddingLeft="35px"
                  lineHeight="2rem"
                  sx={{ fontFamily: "Poppins, sans-serif !important", color: "white", }}
               >
                  {page.name.toUpperCase()}
               </Typography>
            </Link>
      )
   }
   return (
      <>
         <AppBar
            position="sticky"
            sx={{
               height: '10% !important',
               background: "linear-gradient(270deg, #0F1A28 0%, #200F28 50%, #0F1A28 100%)",
               backgroundColor: 'white',
               m: 0,
               width: "100%",
               p: 0,
               fontFamily: "Poppins, sans-serif !important",
            }}
         >
            <Toolbar disableGutters={true} id='etvs23-nav-bar'>
               <Box sx={{ flex: 1, display: { xs: "flex", md: "none" } }}            >
                  <IconButton
                     size="large"
                     aria-label="account of current user"
                     aria-controls="menu-appbar"
                     aria-haspopup="true"
                     onClick={() => setShowMenu(!showMenu)}
                     color="inherit"
                  >
                     <MenuIcon />
                  </IconButton>
               </Box>

               <div className="nav-bar-logo">
                  <Link to={BASE_URL} onClick={() => tracking(250)}>
                     <i>
                        <svg width="193" height="41" viewBox="0 0 193 41" fill="none" xmlns="http://www.w3.org/2000/svg">
                           <path d="M5.26237 7.18045V9.58193H9.96092V12.6934H5.26237V15.3455H10.5874V18.624H1.16942V3.90191H10.5874V7.18045H5.26237ZM29.7961 3.90191V18.624H25.7032V10.5008L22.9258 18.624H19.5011L16.7028 10.4381V18.624H12.6099V3.90191H17.559L21.2552 13.4661L24.8679 3.90191H29.7961ZM36.2189 7.18045V9.58193H40.9175V12.6934H36.2189V15.3455H41.5439V18.624H32.126V3.90191H41.5439V7.18045H36.2189ZM51.0215 18.624L48.0979 13.1946H47.6594V18.624H43.5664V3.90191H50.0191C51.2024 3.90191 52.2048 4.11074 53.0262 4.52839C53.8476 4.93211 54.4671 5.49594 54.8847 6.21986C55.3024 6.92987 55.5112 7.73036 55.5112 8.62134C55.5112 9.6237 55.2328 10.5077 54.6759 11.2734C54.1329 12.0252 53.3325 12.5612 52.2744 12.8814L55.5947 18.624H51.0215ZM47.6594 10.3963H49.685C50.2419 10.3963 50.6595 10.2641 50.9379 9.99958C51.2164 9.73507 51.3556 9.35223 51.3556 8.85105C51.3556 8.37771 51.2094 8.00879 50.9171 7.74428C50.6386 7.46585 50.2279 7.32663 49.685 7.32663H47.6594V10.3963ZM66.7696 8.74664C66.5329 8.35683 66.2058 8.05752 65.7881 7.84869C65.3844 7.63987 64.9041 7.53546 64.3472 7.53546C63.317 7.53546 62.5026 7.86958 61.904 8.53781C61.3193 9.20605 61.0269 10.104 61.0269 11.2316C61.0269 12.4985 61.3402 13.4661 61.9666 14.1343C62.607 14.7886 63.5328 15.1158 64.744 15.1158C66.1779 15.1158 67.2012 14.4684 67.8137 13.1737H63.6999V10.2293H71.3428V14.1969C71.0226 14.9766 70.5493 15.7074 69.9228 16.3896C69.3103 17.0718 68.5307 17.6356 67.584 18.0811C66.6373 18.5127 65.5584 18.7284 64.3472 18.7284C62.8715 18.7284 61.5629 18.4152 60.4213 17.7887C59.2937 17.1483 58.4166 16.2643 57.7901 15.1367C57.1776 13.9951 56.8713 12.6934 56.8713 11.2316C56.8713 9.7838 57.1776 8.49605 57.7901 7.3684C58.4166 6.22682 59.2937 5.3428 60.4213 4.71633C61.549 4.07593 62.8507 3.75574 64.3263 3.75574C66.1779 3.75574 67.7093 4.20123 68.9205 5.09221C70.1317 5.9832 70.8834 7.20134 71.1758 8.74664H66.7696ZM77.27 3.90191V18.624H73.1771V3.90191H77.27ZM93.2371 18.624H89.1441L83.6938 10.3963V18.624H79.6009V3.90191H83.6938L89.1441 12.234V3.90191H93.2371V18.624ZM104.966 8.74664C104.729 8.35683 104.402 8.05752 103.984 7.84869C103.58 7.63987 103.1 7.53546 102.543 7.53546C101.513 7.53546 100.699 7.86958 100.1 8.53781C99.5153 9.20605 99.223 10.104 99.223 11.2316C99.223 12.4985 99.5362 13.4661 100.163 14.1343C100.803 14.7886 101.729 15.1158 102.94 15.1158C104.374 15.1158 105.397 14.4684 106.01 13.1737H101.896V10.2293H109.539V14.1969C109.219 14.9766 108.745 15.7074 108.119 16.3896C107.506 17.0718 106.727 17.6356 105.78 18.0811C104.833 18.5127 103.754 18.7284 102.543 18.7284C101.068 18.7284 99.759 18.4152 98.6174 17.7887C97.4898 17.1483 96.6127 16.2643 95.9862 15.1367C95.3737 13.9951 95.0674 12.6934 95.0674 11.2316C95.0674 9.7838 95.3737 8.49605 95.9862 7.3684C96.6127 6.22682 97.4898 5.3428 98.6174 4.71633C99.7451 4.07593 101.047 3.75574 102.522 3.75574C104.374 3.75574 105.905 4.20123 107.117 5.09221C108.328 5.9832 109.079 7.20134 109.372 8.74664H104.966ZM126.459 3.90191V7.15957H122.533V18.624H118.44V7.15957H114.556V3.90191H126.459ZM132.066 7.18045V9.58193H136.765V12.6934H132.066V15.3455H137.391V18.624H127.973V3.90191H137.391V7.18045H132.066ZM138.912 11.2316C138.912 9.7838 139.212 8.49605 139.81 7.3684C140.423 6.22682 141.286 5.3428 142.4 4.71633C143.513 4.07593 144.794 3.75574 146.242 3.75574C148.08 3.75574 149.625 4.24995 150.878 5.23839C152.131 6.2129 152.938 7.54242 153.3 9.22693H148.894C148.63 8.67007 148.261 8.24546 147.787 7.9531C147.328 7.66075 146.792 7.51457 146.179 7.51457C145.233 7.51457 144.474 7.85565 143.903 8.53781C143.346 9.20605 143.068 10.104 143.068 11.2316C143.068 12.3732 143.346 13.2851 143.903 13.9672C144.474 14.6355 145.233 14.9696 146.179 14.9696C146.792 14.9696 147.328 14.8234 147.787 14.5311C148.261 14.2387 148.63 13.8141 148.894 13.2572H153.3C152.938 14.9418 152.131 16.2782 150.878 17.2667C149.625 18.2412 148.08 18.7284 146.242 18.7284C144.794 18.7284 143.513 18.4152 142.4 17.7887C141.286 17.1483 140.423 16.2643 139.81 15.1367C139.212 13.9951 138.912 12.6934 138.912 11.2316ZM168.415 3.90191V18.624H164.322V12.7143H159.331V18.624H155.238V3.90191H159.331V9.43576H164.322V3.90191H168.415Z" fill="white" />
                           <path d="M18.372 21.9537L13.2975 36.6758H8.05604L2.96073 21.9537H7.34604L10.6872 32.5828L14.0075 21.9537H18.372ZM23.7402 25.2322V27.6337H28.4388V30.7452H23.7402V33.3972H29.0652V36.6758H19.6473V21.9537H29.0652V25.2322H23.7402ZM44.7239 36.6758H40.631L35.1807 28.4481V36.6758H31.0877V21.9537H35.1807L40.631 30.2858V21.9537H44.7239V36.6758ZM58.144 21.9537V25.2113H54.2181V36.6758H50.1251V25.2113H46.241V21.9537H58.144ZM63.6677 21.9537V30.4946C63.6677 31.2881 63.8487 31.9007 64.2107 32.3322C64.5866 32.7638 65.1504 32.9796 65.9021 32.9796C66.6539 32.9796 67.2177 32.7638 67.5936 32.3322C67.9834 31.8867 68.1783 31.2742 68.1783 30.4946V21.9537H72.2713V30.4946C72.2713 31.845 71.9859 33.0005 71.4151 33.9611C70.8443 34.9077 70.0647 35.6247 69.0763 36.112C68.1018 36.5853 67.0159 36.822 65.8186 36.822C64.6214 36.822 63.5494 36.5853 62.6027 36.112C61.67 35.6247 60.9321 34.9077 60.3892 33.9611C59.8602 33.0144 59.5957 31.8589 59.5957 30.4946V21.9537H63.6677ZM81.9798 36.6758L79.0563 31.2464H78.6177V36.6758H74.5248V21.9537H80.9775C82.1608 21.9537 83.1632 22.1625 83.9845 22.5801C84.8059 22.9839 85.4254 23.5477 85.8431 24.2716C86.2607 24.9816 86.4695 25.7821 86.4695 26.6731C86.4695 27.6755 86.1911 28.5595 85.6342 29.3252C85.0913 30.0769 84.2908 30.6129 83.2328 30.9331L86.5531 36.6758H81.9798ZM78.6177 28.4481H80.6433C81.2002 28.4481 81.6179 28.3159 81.8963 28.0513C82.1747 27.7868 82.3139 27.404 82.3139 26.9028C82.3139 26.4295 82.1678 26.0605 81.8754 25.796C81.597 25.5176 81.1863 25.3784 80.6433 25.3784H78.6177V28.4481ZM92.4238 25.2322V27.6337H97.1223V30.7452H92.4238V33.3972H97.7488V36.6758H88.3308V21.9537H97.7488V25.2322H92.4238Z" fill="#CF1B5B" />
                           <path d="M109.323 36.822C107.611 36.822 106.205 36.4182 105.105 35.6108C104.005 34.7894 103.413 33.62 103.33 32.1025H107.694C107.736 32.6176 107.889 32.9935 108.154 33.2302C108.418 33.4668 108.759 33.5852 109.177 33.5852C109.553 33.5852 109.859 33.4947 110.096 33.3137C110.346 33.1188 110.472 32.8543 110.472 32.5202C110.472 32.0886 110.27 31.7545 109.866 31.5178C109.462 31.2812 108.808 31.0166 107.903 30.7243C106.942 30.4041 106.163 30.0978 105.564 29.8055C104.98 29.4992 104.464 29.0607 104.019 28.4899C103.587 27.9052 103.372 27.1464 103.372 26.2137C103.372 25.267 103.608 24.4596 104.082 23.7913C104.555 23.1092 105.209 22.5941 106.045 22.246C106.88 21.898 107.826 21.724 108.885 21.724C110.597 21.724 111.961 22.1277 112.977 22.9351C114.008 23.7287 114.558 24.8494 114.627 26.2972H110.179C110.165 25.8517 110.026 25.5176 109.762 25.2949C109.511 25.0721 109.184 24.9607 108.78 24.9607C108.474 24.9607 108.223 25.0512 108.028 25.2322C107.833 25.4132 107.736 25.6707 107.736 26.0049C107.736 26.2833 107.84 26.5269 108.049 26.7357C108.272 26.9307 108.543 27.1047 108.864 27.2578C109.184 27.397 109.657 27.578 110.284 27.8008C111.216 28.1209 111.982 28.4411 112.581 28.7613C113.193 29.0676 113.715 29.5061 114.147 30.0769C114.592 30.6338 114.815 31.3438 114.815 32.2069C114.815 33.084 114.592 33.8706 114.147 34.5667C113.715 35.2627 113.082 35.8126 112.247 36.2164C111.425 36.6201 110.451 36.822 109.323 36.822ZM120.727 21.9537V30.4946C120.727 31.2881 120.908 31.9007 121.27 32.3322C121.646 32.7638 122.21 32.9796 122.962 32.9796C123.714 32.9796 124.277 32.7638 124.653 32.3322C125.043 31.8867 125.238 31.2742 125.238 30.4946V21.9537H129.331V30.4946C129.331 31.845 129.045 33.0005 128.475 33.9611C127.904 34.9077 127.124 35.6247 126.136 36.112C125.161 36.5853 124.075 36.822 122.878 36.822C121.681 36.822 120.609 36.5853 119.662 36.112C118.73 35.6247 117.992 34.9077 117.449 33.9611C116.92 33.0144 116.655 31.8589 116.655 30.4946V21.9537H120.727ZM148.771 21.9537V36.6758H144.678V28.5525L141.9 36.6758H138.476L135.677 28.4899V36.6758H131.584V21.9537H136.534L140.23 31.5178L143.842 21.9537H148.771ZM168.287 21.9537V36.6758H164.194V28.5525L161.416 36.6758H157.992L155.193 28.4899V36.6758H151.1V21.9537H156.05L159.746 31.5178L163.358 21.9537H168.287ZM174.71 21.9537V36.6758H170.617V21.9537H174.71ZM188.129 21.9537V25.2113H184.203V36.6758H180.11V25.2113H176.226V21.9537H188.129Z" fill="white" />
                           <rect x="180.285" y="3.24902" width="3.82875" height="10.3376" fill="#CF1B5B" />
                           <path d="M187.17 4.52906C188.953 5.52549 190.333 7.03042 191.1 8.81487C191.868 10.5993 191.981 12.5656 191.422 14.4145C190.863 16.2635 189.663 17.8938 188.004 19.0575C186.346 20.2212 184.319 20.8546 182.233 20.8612C180.147 20.8678 178.116 20.2474 176.449 19.0942C174.781 17.9411 173.569 16.3184 172.996 14.4731C172.423 12.6278 172.521 10.6608 173.276 8.87153C174.03 7.08224 175.399 5.56857 177.174 4.56083L179.411 7.89588C178.425 8.45516 177.666 9.29523 177.247 10.2883C176.829 11.2813 176.774 12.3729 177.092 13.3971C177.41 14.4212 178.083 15.3218 179.008 15.9618C179.933 16.6017 181.061 16.9461 182.218 16.9424C183.376 16.9387 184.501 16.5872 185.421 15.9414C186.342 15.2955 187.008 14.3907 187.318 13.3646C187.628 12.3384 187.566 11.2472 187.14 10.2568C186.714 9.26647 185.948 8.43125 184.958 7.87825L187.17 4.52906Z" fill="url(#paint0_linear_3180_8047)" />
                           <defs>
                              <linearGradient id="paint0_linear_3180_8047" x1="171.489" y1="13.8771" x2="192.619" y2="13.8771" gradientUnits="userSpaceOnUse">
                                 <stop stopColor="#940046" />
                                 <stop offset="0.505208" stopColor="#CF1B5B" />
                              </linearGradient>
                           </defs>
                        </svg>
                     </i>
                  </Link>
               </div>
               <div className="nav-bar-tittle">
                  Silicon Valley
                  <br />
                  May 10 - 11, 2023
               </div>
               <Typography
                  variant="h6"
                  noWrap
                  component="div"
                  sx={{
                     flexGrow: 2,
                     display: {
                        xs: "flex",
                        md: "none",
                        fontFamily: "Poppins, sans-serif !important",
                     },
                  }}
               >
               </Typography>
               <Box
                  sx={{
                     fontSize: "14px",
                     color: "green",
                     flex: 0.6,
                     justifyContent: "space-around",
                     alignItems: "center",
                     display: { xs: "none", md: "flex", },
                  }}
               >
                  {pages.map((page, i) => (
                     <NavLinkButton page={page} key={i} />
                  ))}
               </Box>
               <Box sx={{ flex: 0.3, display: width < 1000 ? "none" : "relative" }} >
                  <div className="nav-bar-buttons" >
                     <NavButton name={"tickets"} link={BASE_URL + 'registration'} />
                     <NavButton name={'present'} link={BASE_URL + 'startups'} />
                  </div>
                  <Menu
                     sx={{ mt: "45px" }}
                     id="menu-appbar"
                     anchorEl={anchorElUser}
                     anchorOrigin={{
                        vertical: "top",
                        horizontal: "right",
                     }}
                     keepMounted
                     transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                     }}
                     open={Boolean(anchorElUser)}
                     onClose={handleCloseUserMenu}
                  >
                     {settings.map((setting) => (

                        <MenuItem key={setting} onClick={handleCloseUserMenu}>
                           <Typography textAlign="center">{setting}</Typography>
                        </MenuItem>
                     ))}
                  </Menu>
               </Box>
            </Toolbar>
            {showMenu &&
               <div className="nav-bar-menu" >
                  <ul style={{ paddingTop: "1rem", paddingBottom: "1rem", marginBottom: "0" }}>
                     {pages.map((page) => (
                        <li
                           key={page.name}
                           onClick={() => setShowMenu(!showMenu)}
                        >
                           <NavLinkButtonMobile page={page} />
                        </li>
                     ))}
                  </ul>
                  <div className="menu-btns">
                     <NavButton name={"tickets"} style={{ width: "100%" }} link={BASE_URL + 'registration'} onClick={() => { setShowMenu(false) }} />
                     <br />
                     <NavButton name={'present'} link={BASE_URL + 'startups'} onClick={() => setShowMenu(false)} />
                  </div>
               </div>
            }
            {deadline > new Date() && <SpecialOffer deadline={deadline} />}
         </AppBar>
      </>
   );
};
